export enum ContractRequestTypes {
    New = 1,
    Change = 2
}
